module.exports={render:function (){var _vm=this;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "row"
  }, [_vm._h('hr'), " ", _vm._h('div', {
    staticClass: "col-md-6 col-md-offset-3"
  }, [_vm._h('div', {
    staticClass: "panel panel-default"
  }, [_vm._h('div', {
    staticClass: "panel-heading"
  }, [_vm._h('h3', ["About PDosage ", _vm._h('span', {
    staticClass: "version"
  })])]), " ", _vm._h('div', {
    staticClass: "panel-body"
  }, [_vm._h('p', ["PDosage is a web application for calculating dosage of some commonly used drugs. Although it's primarily designed for the practice of Pediatrics, it also provides adult doses of drugs, making it useful for other disciplines too."]), " ", _vm._h('p', ["PDosage is written in Javascript."]), " ", _vm._h('p', ["App Version: ", _vm._h('span', {
    staticClass: "version"
  })]), " ", _vm._h('p', ["Data version: ", _vm._h('span', {
    staticClass: "data-ver"
  })]), " ", _vm._h('p', ["Copyright © ", _vm._h('span', {
    staticClass: "copyright",
    attrs: {
      "data-start": "2016"
    }
  }, ["2016"]), " Agnibho Mondal"]), " ", _vm._h('p', ["E-mail: mail@agnibho.com"])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-388c422e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AboutView.vue
// module id = 144
// module chunks = 0